import CloseAccountSuccessful from 'components/GlobalModals/CloseAccountSuccessful/CloseAccountSuccessful';
import { withCloseAccountSuccessfulProps } from 'viewModel/globalModals/closeAccountSuccessful/withCloseAccountSuccessful';

export default withCloseAccountSuccessfulProps(CloseAccountSuccessful);
